import { IconProps } from './components/SubHeader/Icon';
import Integration from '../../models/Integration';

export type IntegrationCategory = {
  name: string;
  label: IconProps['icon'];
  description: string;
  integrations?: Integration[];
};

export type SyncFFT = 'perpetual' | 'single' | 'off';

export enum IntegrationErrorTypes {
  PARTNER_INTEGRATION_ERROR,
  ORGANIZATIONS_ERROR,
  PATCH_INTEGRATION_ERROR,
  PATCH_INTEGRATION_SUCCESS,
  DEEP_ACTION_SUCCESS,
  GET_INTEGRATIONS_ERROR,
  AUTHENTICATION_ERROR,
  INTEGRATION_SUCCESS,
  INTEGRATION_ERROR,
}

export type ConnectedUserAccount = { user_id: string; name: string };

export interface AuthAccount {
  account_id: string;
  auth_config: AuthConfig;
  created: string;
  integration_id?: string;
  modified: string;
  org_id: string;
  partner: string;
  settings: Settings;
  user_id: string;
  last_successful_sync?: string;
}

export interface AutoFft {
  is_active: boolean;
}

export interface OperationCount {
  account_id: string;
  operation_count: number;
}

export type GetOperationCountParams = {
  org_id: string;
  partner: string;
};

export interface AuthConfig {
  access_token: string;
  refresh_token: string;
  token_created: string;
  expires_in: number;
  token_type?: string;
  scope?: string;
  responseDurationMs?: number;
  id_token?: string;
  errorCode: any;
  requestEndTime?: string;
  error?: string;
  requestStartTime?: string;
  isError?: boolean;
  error_description: any;
  httpStatusCode?: number;
}

export interface Settings {
  end_date?: string;
  auto_fft?: AutoFft;
  organizations?: string[];
  up_to?: boolean;
  between?: boolean;
  start_date?: string;
  with_encryption?: boolean;
  status?: string;
  account_id?: string;
  etags?: { [key: string]: string }[];
  sync_fft?: SyncFFT;
}

export interface AutoFft {
  is_active: boolean;
}

export interface OperationCount {
  account_id: string;
  operation_count: number;
}

export type ConnectedOrganization = { partner_org_id: string; partner_org_name: string };
